// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slick-slide img{display:block;width:100%}@media only screen and (max-width:575px){.slider.slider--3{padding:100px 0}}", ""]);
// Exports
module.exports = exports;
